import { initialiseFirebase } from "initFirebase";
import { useMemo } from "react";

export function useFirebaseApp() {
  return useMemo(() => initialiseFirebase(), []);
}
